import React from 'react';

const Input = ({ 
  label,
  error,
  helperText,
  type = 'text',
  className = '',
  fullWidth = false,
  icon: Icon,
  endIcon: EndIcon,
  onEndIconClick,
  ...props 
}) => {
  const inputStyles = `
    px-4 py-3 rounded-2xl border bg-[var(--surface-card)]
    ${error ? 'border-error focus:border-error focus:ring-error/20' : 'border-border focus:border-primary focus:ring-primary/20'}
    focus:ring-2 outline-none transition-gentle
    text-[var(--text-primary)] placeholder-[var(--text-muted)]
    disabled:bg-[var(--surface-soft-1)] disabled:cursor-not-allowed
  `;
  
  const widthClass = fullWidth ? 'w-full' : '';
  
  return (
    <div className={`${widthClass} ${className}`}>
      {label && (
        <label className="block text-textSecondary font-medium mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && (
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <Icon className="w-5 h-5 text-neutral-400" />
          </div>
        )}
        <input
          type={type}
          className={`${inputStyles} ${Icon ? 'pl-10' : ''} ${EndIcon ? 'pr-10' : ''} ${widthClass}`}
          {...props}
        />
        {EndIcon && (
          <button
            type="button"
            onClick={onEndIconClick}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-textMuted hover:text-textSecondary focus:outline-none transition-gentle"
            tabIndex={-1}
          >
            <EndIcon className="w-5 h-5" />
          </button>
        )}
      </div>
      {error && (
        <p className="mt-1 text-sm text-error">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm text-textMuted">{helperText}</p>
      )}
    </div>
  );
};

export default Input;
